"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = exports.CarouselItem = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var PropTypes = require("prop-types");
var React = require("react");
var react_transition_group_1 = require("react-transition-group");
var usePrevious_1 = require("./../../utils/usePrevious");
var Icon_1 = require("./../Icon");
var arrowsColour = honeycomb_1.Styles.Colors.Aliases.backgroundLight;
var CarouselItem = function (_a) {
    var children = _a.children, className = _a.className, controlId = _a.controlId, direction = _a.direction, isActive = _a.isActive;
    return (React.createElement("div", { id: controlId, className: "carousel-item" + (className ? " " + className : '') + (isActive ? ' active' : '') + " item-" + direction }, children));
};
exports.CarouselItem = CarouselItem;
exports.CarouselItem.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
    controlId: PropTypes.string.isRequired,
    direction: PropTypes.oneOf(['next', 'prev']),
    isActive: PropTypes.bool,
};
var Carousel = function (_a) {
    var _b = _a.activeIndex, activeSlideIndex = _b === void 0 ? 0 : _b, carouselItems = _a.children, headingRefs = _a.headingRefs, hideArrows = _a.hideArrows, onSelect = _a.onSelect;
    var prevActiveSlideIndex = (0, usePrevious_1.usePrevious)({ activeSlideIndex: activeSlideIndex });
    var slidesLength = carouselItems.length;
    var onClickPrev = function () {
        onSelect(activeSlideIndex - 1);
    };
    var onClickNext = function () {
        onSelect(activeSlideIndex + 1);
    };
    var makeOnSelect = function (index, onSelectFunc) { return function () {
        onSelectFunc(index);
    }; };
    // a11y: Manage focus on first element in the slide, in most cases would be heading
    var setFocusOnSlideChange = function () {
        var _a;
        if (headingRefs) {
            (_a = headingRefs[activeSlideIndex]) === null || _a === void 0 ? void 0 : _a.current.focus();
        }
    };
    return (React.createElement("div", { className: "carousel" },
        React.createElement("div", { className: "carousel-controls" },
            activeSlideIndex !== 0 && !hideArrows &&
                React.createElement("button", { className: "carousel-previous", onClick: onClickPrev },
                    React.createElement(Icon_1.Icon, { className: "icon-rotated", screenreader: "Previous Slide", svgArgs: {
                            fill1: arrowsColour,
                        }, symbol: "controlChevronForward24", type: "svginline" })),
            activeSlideIndex !== slidesLength - 1 && !hideArrows &&
                React.createElement("button", { className: "carousel-next", onClick: onClickNext },
                    React.createElement(Icon_1.Icon, { screenreader: "Next Slide", svgArgs: {
                            fill1: arrowsColour,
                        }, symbol: "controlChevronForward24", type: "svginline" })),
            React.createElement("div", { className: "carousel-indicators" },
                React.createElement(React.Fragment, null, carouselItems === null || carouselItems === void 0 ? void 0 :
                    carouselItems.map(function (_, index) {
                        return (React.createElement("span", { onClick: makeOnSelect(index, onSelect), key: "indicator-" + index, className: "carousel-indicator" + (activeSlideIndex === index ? ' active' : '') }));
                    }),
                    React.createElement("span", { className: "sr-only", "aria-live": "assertive", "aria-atomic": "true" }, "Slide " + (activeSlideIndex + 1) + " of " + slidesLength)))),
        React.createElement("div", { id: "carousel-items", className: "carousel-items" }, carouselItems === null || carouselItems === void 0 ? void 0 : carouselItems.map(function (item, index) {
            if (item.type === exports.CarouselItem) {
                return (React.createElement(react_transition_group_1.CSSTransition, { key: index, in: index === activeSlideIndex, timeout: 350, classNames: "animation", onEntered: setFocusOnSlideChange }, React.cloneElement(item, {
                    carouselItemsLength: slidesLength,
                    direction: (prevActiveSlideIndex === null || prevActiveSlideIndex === void 0 ? void 0 : prevActiveSlideIndex.activeSlideIndex) && (prevActiveSlideIndex === null || prevActiveSlideIndex === void 0 ? void 0 : prevActiveSlideIndex.activeSlideIndex) > activeSlideIndex ? 'prev' : 'next',
                    index: index,
                    isActive: index === activeSlideIndex,
                    key: index,
                })));
            }
            throw new Error("You need to add <CarouselItem> as a child, not a " + item.type);
        }))));
};
exports.Carousel = Carousel;
exports.Carousel.defaultProps = {
    activeIndex: 0,
    hideArrows: false,
};
exports.Carousel.propTypes = {
    activeIndex: PropTypes.number,
    children: PropTypes.arrayOf(PropTypes.element.isRequired).isRequired,
    /**
     * Need receive the array of Refs for first element of each slide for managing focus
     */
    headingRefs: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
        PropTypes.any,
    ])).isRequired,
    onSelect: PropTypes.func.isRequired,
};
